import {
    GET_NOTIFICATION_LISTING,
    GET_NOTIFICATION_LISTING_SUCCESS,
    GET_NOTIFICATION_LISTING_FAIL,
    GET_NOTIFICATION_DETAILS,
    GET_NOTIFICATION_DETAILS_SUCCESS,
    GET_NOTIFICATION_DETAILS_FAIL,
    ADD_NOTIFICATION,
    ADD_NOTIFICATION_SUCCESS,
    ADD_NOTIFICATION_FAIL,
    UPDATE_NOTIFICATION,
    UPDATE_NOTIFICATION_SUCCESS,
    UPDATE_NOTIFICATION_FAIL,
    DELETE_NOTIFICATION,
    DELETE_NOTIFICATION_SUCCESS,
    DELETE_NOTIFICATION_FAIL,
    EXPORT_NOTIFICATION,
    EXPORT_NOTIFICATION_SUCCESS,
    EXPORT_NOTIFICATION_FAIL,
    RESET_NOTIFICATION_STATE,
    RESET_NOTIFICATION_ACTION_STATE,
    READ_NOTIFICATION,
    READ_NOTIFICATION_SUCCESS,
    READ_NOTIFICATION_FAIL,
    READ_ALL_NOTIFICATION,
    READ_ALL_NOTIFICATION_SUCCESS,
    READ_ALL_NOTIFICATION_FAIL,
} from "./actionTypes";

export const getNotificationListing = (payload) => {
    return {
        type: GET_NOTIFICATION_LISTING,
        payload: payload
    };
};

export const getNotificationListingSuccess = categories => ({
    type: GET_NOTIFICATION_LISTING_SUCCESS,
    payload: categories,
});

export const getNotificationListingFail = error => ({
    type: GET_NOTIFICATION_LISTING_FAIL,
    payload: error,
});

export const getNotificationDetails = notificationId => ({
    type: GET_NOTIFICATION_DETAILS,
    payload: notificationId,
});

export const getNotificationDetailsSuccess = notification => ({
    type: GET_NOTIFICATION_DETAILS_SUCCESS,
    payload: notification,
});

export const getNotificationDetailsFail = error => ({
    type: GET_NOTIFICATION_DETAILS_FAIL,
    payload: error,
});

export const createNotification = notification => ({
    type: ADD_NOTIFICATION,
    payload: notification,
});

export const createNotificationSuccess = notification => ({
    type: ADD_NOTIFICATION_SUCCESS,
    payload: notification,
});

export const createNotificationFail = error => ({
    type: ADD_NOTIFICATION_FAIL,
    payload: error,
});

export const updateNotification = notification => ({
    type: UPDATE_NOTIFICATION,
    payload: notification,
});

export const updateNotificationSuccess = notification => ({
    type: UPDATE_NOTIFICATION_SUCCESS,
    payload: notification,
});

export const updateNotificationFail = error => ({
    type: UPDATE_NOTIFICATION_FAIL,
    payload: error,
});

export const deleteNotification = ({ id, multiple }) => ({
    type: DELETE_NOTIFICATION,
    payload: { id, multiple },
});

export const deleteNotificationSuccess = notificationId => ({
    type: DELETE_NOTIFICATION_SUCCESS,
    payload: notificationId,
});

export const deleteNotificationFail = error => ({
    type: DELETE_NOTIFICATION_FAIL,
    payload: error,
});

export const exportNotification = (payload) => ({
    type: EXPORT_NOTIFICATION,
    payload: payload
});

export const exportNotificationSuccess = data => ({
    type: EXPORT_NOTIFICATION_SUCCESS,
    payload: data,
});

export const exportNotificationFail = error => ({
    type: EXPORT_NOTIFICATION_FAIL,
    payload: error,
});

//reset
export const resetNotificationState = () => {
    return {
        type: RESET_NOTIFICATION_STATE,
    }
}
//reset attachment
export const resetNotificationActionState = () => {
    return {
        type: RESET_NOTIFICATION_ACTION_STATE,
    }
}

export const getReadNotification = readNotification => {
    return{
        type: READ_NOTIFICATION,
        payload: readNotification,
    }
}

export const getReadNotificationSuccess = readNotification => {
    return {
        type: READ_NOTIFICATION_SUCCESS,
        payload: readNotification,
    }
}

export const getReadNotificationFail = error => {
    return {
        type: READ_NOTIFICATION_FAIL,
        payload: error,
    }
}

export const getReadAllNotification = readNotification => {
    return{
        type: READ_ALL_NOTIFICATION,
        payload: readNotification,
    }
}

export const getReadAllNotificationSuccess = readNotification => {
    return {
        type: READ_ALL_NOTIFICATION_SUCCESS,
        payload: readNotification,
    }
}

export const getReadAllNotificationFail = error => {
    return {
        type: READ_ALL_NOTIFICATION_FAIL,
        payload: error,
    }
}
